import React from 'react'
import Header from '../components/header/Header'
import Panel from '../components/panel/Panel'
import Generator from '../components/generator/Generator'

const GeneratorPage: React.FC = () => {
    return (
        <>
            <Header />
            <Generator />
            <Panel />
        </>
    )
}

export default GeneratorPage
